import React, { useState, useEffect } from "react";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import Users from "./Pages/Users";
import Bills from "./Pages/Bills";
import DashboardContent from "./Pages/DashboardContent";
import Sidebar from "../Common/Sidebar";
import AdminProfile from "./Pages/AdminProfile";
import AdminHeader from "./AdminHeader";
import Signature from "./Pages/Signature";
import Supports from "./Pages/supports";
import ProfilePage from "../Profile";

const Dashboard = ({ user }) => {
  const navigate = useNavigate();
  const location = useLocation();
  // Initialize active section based on current URL
  const [activeSection, setActiveSection] = useState(
    location.pathname.split("/")[2] || "dashboard"
  );
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    // Update active section when the URL changes
    setActiveSection(location.pathname.split("/")[2] || "dashboard");
  }, [location]);

  const handleSectionClick = (section) => {
    setActiveSection(section); // Update the active section
    navigate(`/dashboard/${section.toLowerCase()}`);
  };

  return (
    <div className="flex flex-col h-screen">
      {/* Full-Width Header */}
      <AdminHeader
        user={user}
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        className="border-b-2"
      />

      {/* Main Layout (Sidebar + Content) */}
      <div className="flex flex-1 flex-col md:flex-row">
        {/* Sidebar Inside Main Content */}
        <Sidebar
          activeSection={activeSection}
          onSectionClick={handleSectionClick}
          user={user}
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
          className="w-full md:w-1/4" // Adjust width for mobile and desktop
        />

        {/* Main Content */}
        <div className="flex-1 bg-white border-l-2">
          <h3 className="text-[32px] text-gray-700 mx-4 my-2">
            {activeSection.charAt(0).toUpperCase() +
              activeSection.slice(1).toLowerCase()}
          </h3>

          {user ? (
            <Routes>
              <Route
                path="dashboard"
                element={<DashboardContent user={user} />}
              />
              <Route path="users" element={<Users user={user} />} />
              <Route path="E-Signature" element={<Signature />} />
              <Route path="profile" element={<ProfilePage user={user} />} />
              <Route path="bills" element={<Bills user={user} />} />
              <Route path="Supports" element={<Supports user={user} />} />
              <Route path="Setting" element={<AdminProfile user={user} />} />
              <Route path="*" element={<DashboardContent user={user} />} />
            </Routes>
          ) : (
            <Navigate to="/login" replace />
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
